import {
  WorkflowTemplateValues,
  WorkflowConfiguration,
  STEP_COMPLETION_ACTION,
  StepCompletionAction,
} from 'models/WorkflowConfiguration';

export const getIsCompletionAction = (action: StepCompletionAction) =>
  action === STEP_COMPLETION_ACTION.ASK_PROGRESSION_QUESTION;

export const extractUpdateValues = (
  values: WorkflowTemplateValues,
  modified: Record<string, boolean>,
) => {
  const updateValues: Partial<WorkflowConfiguration> = {};

  const { generalRules, specificRules, maxCapacity } = values || {};

  if (modified['generalRules.immediatelyAcceptVerifiedBuyers'])
    updateValues.immediatelyAcceptVerifiedBuyers =
      generalRules.immediatelyAcceptVerifiedBuyers;

  if (modified['specificRules.automaticallySendNDA'])
    updateValues.automaticallySendNDA = specificRules.automaticallySendNDA;

  if (modified.maxCapacity) updateValues.maxCapacity = maxCapacity;

  return updateValues;
};

export const extractQuestionUpdateValues = (values: WorkflowTemplateValues) => {
  const updateValues: Partial<WorkflowConfiguration> = {};

  const { completionAction, progressionQuestion } = values || {};

  updateValues.completionAction = completionAction;

  if (getIsCompletionAction(completionAction)) {
    updateValues.progressionQuestion = {
      ...progressionQuestion,
      answers: progressionQuestion.answers.filter(({ text }) => !!text),
    };
  }

  return updateValues;
};
